module.exports = __webpack_public_path__ + "img/seal1.7176c099.png";